import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { onConsentChange } from '../event.js';
import { EmptyConsent } from '../types.js';

const CookieConsentContext = /*#__PURE__*/ React.createContext(EmptyConsent);
CookieConsentContext.displayName = 'CookieConsentContext';
const CookieConsentContextProvider = ({ children , cookies , consentProvider ,  })=>{
    const [cookiesState, setCookiesState] = useState(cookies);
    useEffect(()=>{
        // Set the cookie state on mount (necessary if the page is cached in the browser with the old cookie setting)
        setCookiesState(Cookies.get());
        onConsentChange(()=>{
            setCookiesState(Cookies.get());
        });
    }, []);
    return /*#__PURE__*/ React.createElement(CookieConsentContext.Provider, {
        value: consentProvider(cookiesState)
    }, children);
};
const useCookieConsentContext = ()=>React.useContext(CookieConsentContext)
;

export { CookieConsentContextProvider, useCookieConsentContext };
//# sourceMappingURL=CookieConsentContext.js.map
